import { Suspense } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import AppProvider from './providers/AppProvider';
import Router from './router/Router';
import MaintenanceGate from './components/MaintenanceGate';
import AppErrorBoundary from './components/AppErrorBoundary/AppErrorBoundary';

import './styles/theme.css';
import './styles/global.scss';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const App = () => {
  return (
    <MaintenanceGate>
      <AppProvider>
        <AppErrorBoundary>
          <Router />
        </AppErrorBoundary>
      </AppProvider>
    </MaintenanceGate>
  );
};

const Wrapped = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-content-center align-items-center h-screen w-screen">
          <ProgressSpinner aria-label="Loading" />
        </div>
      }
    >
      <App />
    </Suspense>
  );
};

export default Wrapped;
